import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUser } from 'Store/Actions/User/UserAction';
import { useMsal } from '@azure/msal-react';

const Avatar = () => {
  const { t } = useTranslation('common');
  const [showInfo, setShowInfo] = useState(false);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const infoRef = useRef(null);
  const { instance } = useMsal();

  const handleAvatarClick = () => {
    setShowInfo(!showInfo);
  };

  const handleClickOutside = (event) => {
    if (infoRef.current && !infoRef.current.contains(event.target)) {
      setShowInfo(false);
    }
  };

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  useEffect(() => {
    if (showInfo) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showInfo]);

  const formatRoles = (roles) => {
    if (!roles || roles.length === 0) {
      return [];
    }
    return roles.filter((value) => value.includes('DS_MTP') || value.includes('DS_GPX'));
  };

  const getInitials = () => {
    if (currentUser?.name) {
      return currentUser.name.charAt(0).toUpperCase();
    }
    if (currentUser?.given_name) {
      return currentUser.given_name.charAt(0).toUpperCase();
    }
    return '';
  };

  const getUserName = () => {
    if (currentUser?.name) {
      return currentUser.name;
    }
    if (currentUser?.given_name && currentUser?.family_name) {
      return `${currentUser.given_name} ${currentUser.family_name}`;
    }
    return '';
  };

  const handleRestartTour = () => {
    window.dispatchEvent(new CustomEvent('mtp:restart-tour'));
    setShowInfo(false);
  };

  return (
    <div className="navbar-nav position-relative avatar-wrapper" ref={infoRef}>
      <Button variant="link" className="p-0 avatar-button" onClick={handleAvatarClick}>
        <div className="avatar-container">{getInitials()}</div>
      </Button>
      {showInfo && (
        <div className="user-info-popup">
          <div className="user-info-header">
            <div className="avatar-container-large">{getInitials()}</div>
            <div>
              <div className="user-name">{getUserName()}</div>
              <div className="user-email">{currentUser.email}</div>
            </div>
          </div>
          <div className="user-roles">{formatRoles(currentUser.roles).join(', ')}</div>
          <Button
            variant="link"
            size="sm"
            className="w-100 mt-2 text-muted text-start text-decoration-none"
            onClick={handleRestartTour}
          >
            <i className="bi bi-question-circle me-2" />
            {t('restartTour', 'Restart guided tour')}
          </Button>
          <Button variant="outline-danger" size="sm" className="w-100 mt-1" onClick={() => instance.logoutRedirect()}>
            <i className="bi bi-box-arrow-right me-2" />
            {t('logout')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Avatar;
